export default __webpack_public_path__ + "static/media/projTrack3Full.760eb1b8.png";